import Api from '../api/Api';

let ApiPlugin = {};

ApiPlugin.install = function(Vue, options = {}) {
    Api.url = options.baseUrl;

    if (options.vueRouter !== undefined) {
        Api.vueRouter = options.vueRouter;
    }

    if (options.headers !== undefined) {
        Api.headers = options.headers;
    }

    Vue.api = Api;
};

export default ApiPlugin;
